// extracted by mini-css-extract-plugin
export var deliveryRow = "_qg-a";
export var fixedHeight = "_qg-4";
export var freightLogo = "_qg-9";
export var fullWidth = "_qg-3";
export var priceColumn = "_qg-5";
export var radioSelected = "_qg-7";
export var radioUnselected = "_qg-6";
export var selectedOption = "_qg-2";
export var selectedOptionContainer = "_qg-1";
export var selection = "_qg-0";
export var tallSkeletonText = "_qg-8";